import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RequestErrorSnackComponent } from './request-error-snack.component';

const DEFAULT_ERROR_DURATION_MS = 5000;

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(private snackBar: MatSnackBar) {}

  showError(message: string, duration = DEFAULT_ERROR_DURATION_MS): void {
    if (message?.length) {
      this.snackBar.open(message, 'Close', {
        duration,
        horizontalPosition: 'center',
        verticalPosition: 'bottom',
        panelClass: ['custom-snackbar'],
      });
    }
  }

  showRequestError(title: string, detail: string, duration = DEFAULT_ERROR_DURATION_MS): void {
    this.snackBar.openFromComponent(RequestErrorSnackComponent, {
      data: { title, detail },
      duration,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: ['custom-snackbar', 'request-error-snackbar-container'],
    });
  }
}
